<template>
  <div v-if="!isLoading">
    <div v-for="(perros, n) in perrosSin" :key="n">
      <div
        v-if="perros.machos.length > 0 && perros.hembras.length > 0"
        class="card border-secondary my-2 mi-borde"
      >
        <div class="card-header">
          {{ razaNombre(perros.raza, compPerros) }}
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-5 pr-1">
              <div class="form-group">
                <label for=""
                  >{{ $t("machos") }} ({{ perros.machos.length }}):</label
                >
                <select class="form-control px-1" v-model="perros.select_macho">
                  <option :value="null">{{ $t("select") }}</option>
                  <option
                    v-for="m in perros.machos"
                    :key="m.dog_id"
                    :value="m.dog_id"
                    >{{ m.nombre }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-5 pl-1">
              <div class="form-group">
                <label for=""
                  >{{ $t("hembras") }} ({{ perros.hembras.length }}):</label
                >
                <select
                  class="form-control px-1"
                  v-model="perros.select_hembra"
                >
                  <option :value="null">{{ $t("select") }}</option>
                  <option
                    v-for="m in perros.hembras"
                    :key="m.dog_id"
                    :value="m.dog_id"
                    >{{ m.nombre }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-2 mt-4 pl-0 text-right">
              <button
                class="btn btn-primary btn-sm mi-btn "
                @click="agregarPareja(perros, false)"
              >
                {{ $t("agregar") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- listado de perros seleccionados -->
    <div
      class="card border-secondary my-2 mi-borde"
      v-if="inscritos.length > 0"
    >
      <div class="card-header">
        {{ $t("inscritos") }} ({{ inscritos.length }})
      </div>
      <div class="card-body">
        <div v-for="(ins, n) in inscritos" :key="n">
          <div class="row">
            <div class="col-10 pt-2">
              <div class="col-12 pl-1">
                {{ $t("macho") }}:
                <b>{{ ins.macho | perroNombre(compPerros) }}</b>
              </div>
              <div class="col-12 pl-1">
                {{ $t("hembra") }}:
                <b>{{ ins.hembra | perroNombre(compPerros) }}</b>
              </div>
            </div>
            <div class="col-2 pt-0">
              <button
                class="btn btn-danger btn-sm mi-btn float-right mt-0"
                @click="eliminarPareja(ins)"
              >
                {{ $t("eliminar") }}
              </button>
              <div class="float-right">
                <b>{{ ins.tarifa.price }} €</b>
              </div>
            </div>
          </div>
          <hr v-if="n + 1 < inscritos.length" />
        </div>
        <!--    {{ inscritos }}  -->
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions } from "vuex";
import { inscriptionMixin } from "@/_mixins/Inscription-mix.js";

export default {
  name: "ins-pareja-comp",
  props: ["datos", "datosNormalizados"],
  data: () => ({
    isLoading: true,
    perros: [],
    inscritos: [],
    perrosSin: {},
    perrosCon: {},
    listaNueva: {}, //aqui guardo un listado sin tocar... por si quiero resetar sin realizar calculos
    tarifas: null,
  }),
  mixins: ["inscriptionMixin"],
  methods: {
    ...mapActions("inscription", ["getListaParejas"]),
    /* funcion para devolver el nombre de la raza de un raza_id, lo buscamos en los propios perros */
    razaNombre(razaId, perros) {
      //filtramos los datos dependiendo del idioma de la page
      const lang = this.$i18n.locale;
      const razaNombre = perros.find((p) => p.dog_breed_id === razaId).breeds
        .translations;
      const tmp = razaNombre.find((r) => r.locale === lang);

      let res = tmp.name;
      if (tmp.variety !== "") res += " " + tmp.variety;
      if (tmp.subvariety !== "") res += " " + tmp.subvariety;
      return res;

      return razaId;
    },
    /* funcion para agregar una pareja */
    agregarPareja(lista, copropietarios) {
      console.log(lista);
      //comprobamos que no estén vacios los selectores
      if (lista.select_macho === null || lista.select_hembra === null) {
        //TODO: Pendiente mostrar dialogo
        alert("Debug debe elegir un macho y una hembra");
        return;
      }
      //eliminamos de la lista principal los perros seleccionados
      let idxM = lista.machos.findIndex((m) => m.dog_id === lista.select_macho);
      let idxH = lista.hembras.findIndex(
        (m) => m.dog_id === lista.select_hembra
      );

      //console.log(lista, idxM, idxH, lista.machos[idxM]);
      //añadimos los perros a la lista de preinscritos
      this.inscritos.push({
        macho: lista.select_macho,
        datos_macho: lista.machos[idxM],
        hembra: lista.select_hembra,
        raza: lista.raza,
        datos_hembra: lista.hembras[idxH],
        copropietarios: copropietarios,
      });

      //los extraemos del array
      lista.machos.splice(idxM, 1);
      lista.hembras.splice(idxH, 1);
      //console.log(lista)

      //finalmente pasamos a null los v-model del grupo
      lista.select_hembra = null;
      lista.select_macho = null;
      this.$emit("emitDatosParejas", this.inscritos);
      this.calcularImporte2();
    },

    /* funcion para eliminar una pareja ya asignada */
    eliminarPareja(datos) {
      let filtro = this.inscritos.filter(
        (i) => i.macho === datos.macho && i.hembra === datos.hembra
      )[0];
      let tmp = this.inscritos.filter(
        (i) => i.macho !== datos.macho && i.hembra !== datos.hembra
      );
      console.log(datos, this.inscritos, filtro);
      //comprobamos si hay copropietarios para agregarlo a su lista
      if (datos.copropietarios === false) {
        console.log("sin coprop", this.perrosSin[datos.raza]);
        this.perrosSin[datos.raza].machos.push(filtro.datos_macho);
        this.perrosSin[datos.raza].hembras.push(filtro.datos_hembra);
      }
      this.inscritos = tmp;
      this.$emit("emitDatosParejas", this.inscritos);
    },

    calcularImporte2(raza) {
      let inscritos = this.inscritos;
      const tarifa = this.tarifas;
      const nacionalidad = this.datos.userData.nationality; //nacionalidad del usuario
      const socio = this.datos.socio === 0 ? false : true;
      const clasePermitida = 9;
      const tarifaNormalizada = normalizarTarifa(tarifa);
      //const tarifaNormalizada = mixNormalizarTarifa(tarifa);

      //console.log("tarifa normalizada ", tarifaNormalizada, tarifas);
      //creamos una lista de inscritos por raza y copro
      const razasSin = _.uniq(
        inscritos.map((i) => {
          if (i.copropietarios === false) return i.raza;
        })
      );
      console.log("razassIn", razasSin);

      //recorremos las razas sin copropietarios
      razasSin.forEach((r) => {
        let ins = inscritos.filter(
          (i) => i.raza === r && i.copropietarios === false
        );
        console.log("razasSin", razasSin, ins);
        //recorremos los inscritos

        ins.forEach((i, n) => {
          console.log("n", n);
          //filtramos por
          const { raza, copropietarios } = i;
          const tarifas = generarTarifaIns(
            tarifaNormalizada,
            i,
            nacionalidad,
            clasePermitida
          );
          let idx = n + 1;
          let maxCount = tarifas.map((tr) => tr.count).length;
          if (idx > maxCount) idx = maxCount - 1;
          const indice = tarifas.findIndex((tr) => tr.count === idx);
          console.log("tarifa" , tarifas[indice])
          const {
            tarifa_id,
            expo_rate_types_id,
            expo_date_inscription_id,
            expo_prices_id,
            count,
            price,
            price_partner,

          } = tarifas[indice];
          ins[n].tarifa = {
            tarifa_id,
            expo_rate_type_id: expo_rate_types_id,
            expo_date_inscription_id,
            expo_prices_id,
            count,
            price,
            price_partner,
            importe: socio ? price_partner : price
          };
          //buscamos en las tarifas
          console.log(ins);
        });
      });
    },

    /* funcion para calcular el importe de la inscripción */
    calcularImporte(datosIns, coprop) {
      const tmp = this.tarifas;
      let salTarifas = [];
      //recorremos las tarifas que nos ha proporcionado la api
      tmp.forEach((t) => {
        console.log(t);
        let inscribe = true;
        //filtramos una tarifa que contenga la clase parejas
        const tarifa = t.expo_rate_types.filter(
          (ta) => !!ta.classes_id && ta.classes_id.split(",").includes("9")
        );

        //si no hay tarifa en el filtro es
        if (tarifa.length === 0) {
          console.log(
            "en esta tarifa no se ha encontrado una adecuada para la clase 9",
            tarifa
          );
          return;
        }

        //recorremos todas las tarifas encontradas
        tarifa.forEach((ta) => {
          let contador = 1; //contador de coincidencias 1 porque tenemos ya clase
          let contFiltros = 0; //contador de filtros
          //si existen limitacion de clases
          if (!!tarifa[0].breeds_id) {
            inscribe = tarifa[0].classes_id.split(",").includes(datosIns.raza);
            if (inscribe) contador++;
            contFiltros++;
          }
          if (!!tarifa[0].countries_id) {
            const natUser = this.datos.userData.nationality;
            inscribe = tarifa[0].countries_id.split(",").inludes(natUser);
            if (inscribe) contador++;
            contFiltros++;
          }

          if (inscribe) {
            salTarifas.push({ datosIns, ta, contador, contFiltros });
          }
        });

        console.log("encontrada tarifa", tarifa);
      });

      console.log(this.tarifas[0], this.datos, salTarifas);
    },
  },
  computed: {
    compPerros() {
      return this.datos.userData.dogs;
    },
  },
  filters: {
    perroNombre(perroid, perros) {
      const perro = perros.find((p) => p.id === perroid);
      return perro.name;
    },
  },
 
  mounted() {
    console.log("llego", this.datosNormalizados, this.datos);
    //creamos los datos para ellos y ellas
    this.perros = _.cloneDeep(this.datosNormalizados);

    //generamos un array con los distintos id de los inscritos
    const dogsId = this.datosNormalizados.map((d) => d.dogId);

    this.getListaParejas(dogsId).then((res) => {
      //data nos devuelve los datos de los perros inscritos y lista/copropietarios_user
      const datosApi = res.data;
      const dogs = this.datos.userData.dogs;
      const dNorm = this.datosNormalizados;
      //tratamos la lista de perros
      const salida = generarListaPerros(dogsId, dNorm, dogs, datosApi);
      //dividimos los perros con copropietarios y sin copropietarios
      this.perrosSin = salida.sin_copropietarios;
      this.perrosCon = salida.con_copropietarios;
      this.tarifas = datosApi.tarifas;
      //recogemos los datos de inscripcion, por defecto null
      const datosParejas = this.datos.datosParejas;
      //this.inscritos = _.cloneDeep(this.datos.datosParejas);
      // console.log("inscritos antes", !!this.inscritos);

      if (!!datosParejas) {
        // console.log("Ojo que hay datos guardados");
        const sal = actualizarInscritos(this.perrosSin, datosParejas, dogsId);
        this.inscritos = sal.newInscritos;
        this.perrosSin = sal.newLista;
        this.$emit("emitDatosParejas", this.inscritos);
      } else {
        this.inscritos = [];
      }
      this.listaNueva = {
        perrosSin: this.perrosSin,
        perrosCon: this.perrosCon,
      };
      this.isLoading = false;
      console.log(res.data, salida, this.datos);
    });
  },
};
/* funciones para generar las listas en base a propietarios de los perros raza y variedad */
const generarListaPerros = (allDogsId, dNorm, dogs, datosApi) => {
  //necesito generar un listado con los perros inscritos,
  //raza variedad
  //mismo propietario inscritos en otra clase
  //si solo 1 propietario.... tbn deben entrar
  //machos 1 , hembras 2
  const dN = dNorm;
  const lista = datosApi.lista;
  const copro = datosApi.copropietarios_user;

  let salida = [];

  //mapeamos las razas, sexos,dogId, idCopros de los datos api - o sea con copropietarios
  const cDogsId = lista.map((d) => d.dog_id); //perros con copropietarios
  const copros = _.uniq(lista.map((d) => d.copropietarios)); //id-copropietarios
  const dogsSinCo = _.difference(allDogsId, cDogsId); //perros sin copropietarios

  //console.log(cRazas, cSexos, copros, allDogsId, cDogsId, dogsSinCo);

  //obj perros sin copropietarios
  let listaSin = listaSinCop(dogsSinCo, dogs, lista);
  //obj perros con copropietarios
  let listaCon = listaConCop(cDogsId, dogs, lista);

  const retorno = {
    sin_copropietarios: listaSin,
    con_copropietarios: listaCon,
  };

  return retorno;
};

/* funcion parar generar la lista de perros parejas sin copropietarios o sea 1 solo propietario */
const listaSinCop = (dogsSinCo, dogs) => {
  let listaSin = [];
  dogsSinCo.forEach((d) => {
    const dog = dogs.find((dg) => dg.id === d);
    //comprobamos si hay mas de un perro de la misma raza y de distinto sexo
    const contDogs = dogs.filter((dg) => dg.dog_breed_id === dog.dog_breed_id)
      .length;
    const contDogsOtroSex = dogs.filter(
      (dg) => dg.dog_breed_id === dog.dog_breed_id && dg.sex_id !== dog.sex_id
    ).length;
    if (contDogs < 2 || contDogsOtroSex === 0) {
      // console.log("perros sin cop salimos y no guardamos nada ya que no hay perros o de otro sexo suf");
      return;
    }
    listaSin.push({
      dog_id: d,
      raza: dog.dog_breed_id,
      nombre: dog.name,
      sexo: dog.sex_id,
    });
  });
  //antes de continuar si el array esta vacío salimos no hacemos nada más
  if (listaSin.length === 0) return listaSin;
  //mapeamos las razas
  let razas = _.uniq(listaSin.map((l) => l.raza));
  console.log("razas unicas", razas);

  let salida = {};
  razas.forEach((r) => {
    const machos = listaSin.filter((l) => l.sexo === 1 && l.raza === r);
    const hembras = listaSin.filter((l) => l.sexo === 2 && l.raza === r);
    //console.log("machos hembras ", machos.length, hembras.length);
    salida[r] = {
      raza: r,
      machos,
      hembras,
      select_macho: null,
      select_hembra: null,
      copropietarios: false,
    };
  });
  //console.log("salida preparada", salida)
  return salida;
};

/* funcion para generar la lista de perros que tiene copropietario que se pueden generar parejas */
const listaConCop = (cDogsId, dogs, lista) => {
  let listaCon = [];
  //perros con copropietarios
  cDogsId.forEach((d) => {
    const dog = dogs.find((dg) => dg.id === d);
    const apiD = lista.find((dg) => dg.dog_id === d);

    //comprobamos si hay mas de un perro de los mismos copropietarios
    const contDogsCop = lista.filter(
      (dg) => dg.copropietarios === apiD.copropietarios
    ).length;
    //comprobamos si hay de la misma raza y del mismo coprop de sexo contrario
    const contDogsCopOtroSex = lista.filter(
      (dg) =>
        dg.copropietarios === apiD.copropietarios && dg.sexo_id !== apiD.sexo_id
    ).length;

    if (contDogsCop < 2 || contDogsCopOtroSex === 0) {
      /*    console.log(
        "salimos y no guardamos nada ya que no hay perros o de otro sexo suf"
      ); */
      return;
    }

    listaCon.push({
      dog_id: d,
      raza: dog.dog_breed_id,
      nombre: dog.name,
      sexo: dog.sex_id,
      copropietarios: apiD.copropietarios,
    });
  });

  //preparamos la salida de los perros con copropietarios
  let salida = {};
  let razas = _.uniq(listaCon.map((l) => l.raza));
  razas.forEach((r) => {
    const machos = listaCon.filter((l) => l.sexo === 1 && l.raza === r);
    const hembras = listaCon.filter((l) => l.sexo === 2 && l.raza === r);
    console.log("machos hembras coprop", machos.length, hembras.length);
    salida[r] = {
      raza: r,
      machos,
      hembras,
    };
  });

  return salida;
};

/* funcion para actualizar los datos si desde inscription-new ya tenemos datos */
const actualizarInscritos = (lista, inscritos, dogsId) => {
  let newInscritos = _.cloneDeep(inscritos);
  let newLista = _.cloneDeep(lista);
  console.log(lista, newInscritos, dogsId);
  //recorremos la lista de inscritos
  newInscritos.forEach((n) => {
    //si hay algun index a -1 es que este perro lo hemos eliminado
    if (dogsId.indexOf(n.macho) === -1 || dogsId.indexOf(n.hembra) === -1) {
      newInscritos = newInscritos.filter(
        (ni) => ni.macho !== n.macho && ni.hembra !== n.hembra
      );
    } else {
      //si existen actualizamos los datos de los selectores
      newLista[n.raza].machos = newLista[n.raza].machos.filter(
        (m) => m.dog_id !== n.macho
      );
      newLista[n.raza].hembras = newLista[n.raza].hembras.filter(
        (m) => m.dog_id !== n.hembra
      );
    }
  });
  return { newInscritos, newLista };
};

/* funcion para normalizar las tarifas y facilitar el filtrado */
const normalizarTarifa = (tarifa) => {
  let result = [];
  tarifa.forEach((t) => {
    console.log("tarifa ite", t);
    const {
      id: tarifa_id,
      expo_id,
      name,
      ini_date,
      end_date,
      expo_rate_types,
    } = t;
    const incl = { tarifa_id, expo_id, name, ini_date, end_date };
    console.log({
      tarifa_id,
      expo_id,
      name,
      ini_date,
      end_date,
      expo_rate_types,
    });
    expo_rate_types.forEach((e) => {
      const {
        id: expo_rate_types_id,
        rate_id,
        expo_date_inscription_id,
        price_type_discount_id,
        breeds_id,
        classes_id,
        countries_id,
        expo_prices,
      } = e;
      const incl2 = {
        expo_rate_types_id,
        rate_id,
        expo_date_inscription_id,
        price_type_discount_id,
        breeds_id,
        classes_id,
        countries_id,
      };
      expo_prices.forEach((ep) => {
        const {
          id: expo_prices_id,
          expo_rate_type_id,
          price,
          price_partner,
          count,
        } = ep;
        const incl3 = {
          expo_prices_id,
          expo_rate_type_id,
          price,
          price_partner,
          count,
        };
        //insertamos el obj dentro de un array
        result.push({ ...incl, ...incl2, ...incl3 });
      });
    });
  });

  return result;
};

/* funcion para devolver las tarifas de una inscripcion */
const generarTarifaIns = (
  tarifaNormalizada,
  datosInscripcion,
  nacionalidad,
  clase_permitida
) => {
  // console.log(datosInscripcion);
  const raza = datosInscripcion.raza.toString();

  const filtro = tarifaNormalizada.filter((tn) => {
    if (
      !!tn.classes_id &&
      tn.classes_id.split(",").includes(clase_permitida.toString())
    ) {
      //si hay paises
      if (!!tn.countries_id) {
        const natCheck = tn.countries_id
          .split(",")
          .includes(nacionalidad.toString())
          ? true
          : false;
        if (!natCheck) return;
      }
      //si hay razas
      if (!!tn.breeds_id) {
        const razaCheck =
          !!tn.breeds_id && tn.countries_id.split(",").includes(raza)
            ? true
            : false;
        if (!razaCheck) return;
      }
      //si llegamos es que es valida la tarifa
      return tn;
    }
  });

  /*   const tarifasId = _.uniq(filtro.map(f => f.tarifa_id));
  let salida = [];
  console.log("tarifas unicas", tarifasId) */

  return filtro;
};
</script>

<style scoped>
select {
  background-color: white !important;
  color: black;
  border: 1px solid #eee;
  padding: 3px 5px 3px 5px !important;
  height: 35px !important;
  border-radius: 5px;
}
.mi-btn {
  margin-top: 5px;
  min-width: 50px !important;
  min-height: 35px;
}

.mi-borde {
  border-color: #cccccc !important;
  border-radius: 5px;
  box-shadow: 1px 2px grey;
}
</style>
